import { Layout, Menu, Spin } from "antd";
import { useEffect, useState } from "react";
import { MenuItem, getOpenKeys, items } from "./helpers";
import { useLocation, useNavigate } from "react-router-dom";
import { sideBarRoutesObjectBasedOnKeys, sidebarRoutes } from "./constants";
import { useCurrentUserContext } from "providers";
import styles from "./styles.module.scss";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { UseLazyApiCallV2 } from "hooks";
import { getCurrentEnviornment } from "utils/constants";

const { Sider } = Layout;
const { SubMenu } = Menu;

export function SideNavbar() {
  const { translator }: any = useLanguageTranslator();

  const [collapsed, setCollapsed] = useState(false);
  const [activeKey, setActiveKey] = useState<string | null>("1");
  const [openKeys, setOpenKeys] = useState<string[] | undefined>([]);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user } = useCurrentUserContext();
  const [getLoginUrl, { isLoading: getLoginUrlLoading }]: any =
    UseLazyApiCallV2({
      method: "POST",
      url: "/prod/login-url",
    });

  //Temporarily set hardcoded keys
  useEffect(() => {
    const activeKey: string = sidebarRoutes[pathname];

    setActiveKey(activeKey);
    setOpenKeys(["sub1"]);
  }, [pathname]);

  // useEffect(() => {
  //   const activeKey: string = sidebarRoutes[pathname];

  //   setActiveKey(activeKey);
  //   setOpenKeys(getOpenKeys(activeKey));
  // }, [pathname]);

  const filteredItems: MenuItem[] =
    items
      .filter((item) => user?.projects?.includes(item.label))
      .concat(items[items.length - 1]) || [];

  const CLIENT_ID =
    getCurrentEnviornment() === "sandbox"
      ? "2a4c7c64-caf6-4744-b969-6c25773fb81a"
      : "d844e72d-dcd9-4111-9877-7531ddac1651";

  const REDIRECT_PATH = "/emails";

  // const REDIRECT_URI = "http://localhost:3000/emails";
  const REDIRECT_URI = "https://dev.d3rb6kfw5m8ga.amplifyapp.com/emails";
  const SCOPE = "openid offline_access Mail.Read";

  // ------------------- PKCE HELPERS -------------------
  function generateRandomString(length: any) {
    const array: any = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  async function sha256(plain: any) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest("SHA-256", data);
  }
  function base64URLEncode(buffer: ArrayBuffer): string {
    return btoa(String.fromCharCode(...Array.from(new Uint8Array(buffer))))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  // ------------------- handleClickInbox -------------------
  const handleClickInbox = async () => {
    try {
      const res = await getLoginUrl({ params: { email: user?.email } });
      if (res?.appToken) {
        navigate(`/emails?appToken=${res?.appToken}`);
      }
      if (res?.body?.login_url) {
        // 1️⃣ PKCE
        const code_verifier = generateRandomString(64);
        localStorage.setItem("pkce_verifier", code_verifier);

        const code_challenge = base64URLEncode(await sha256(code_verifier));

        // 2️⃣ Build OAuth URL
        const params = new URLSearchParams({
          client_id: CLIENT_ID,
          response_type: "code",
          redirect_uri: REDIRECT_URI,
          response_mode: "query",
          scope: SCOPE,
          code_challenge: code_challenge,
          code_challenge_method: "S256",
          state: "xyz",
        });

        window.location.href = `${res?.body?.login_url}?${params}`;
      }
    } catch (error) {
      console.log({ error });
    } finally {
    }
  };

  const handleMenuItemClick = (key: React.Key) => {
    if (key === "3") {
      return handleClickInbox();
    }

    const keyString: string = key.toString();
    // setActiveKey(keyString);
    // setOpenKeys(getOpenKeys(key));
    const activeRoutObj: { [route: string]: string } =
      sideBarRoutesObjectBasedOnKeys[keyString];

    let sourceDashboard = activeRoutObj?.sourceDashoard; // Define source dashboard variable
    let baseRoute = activeRoutObj?.baseRoute; // Define base route variable

    navigate(`${baseRoute}`, { state: { sourceDashboard } });
  };

  return (
    <Spin spinning={getLoginUrlLoading}>
      <Sider
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        width={224}
        className={styles["side-navbar"]}
      >
        <div className={styles["side-nav-logo-Container"]}>
          <img src="/assets/logos/smilesLogo.png" alt="Motion2Coach" />
        </div>
        <div className={styles["sidebar-items"]}>
          <Menu
            theme="light"
            mode="inline"
            style={{ color: "black" }}
            selectedKeys={[activeKey] as any}
            openKeys={openKeys}
            onOpenChange={(openKey) => setOpenKeys(openKey)}
            defaultSelectedKeys={[activeKey] as any} // Set default selected key
          >
            {items.map((item: any) =>
              item.children ? (
                <SubMenu
                  key={item.key}
                  icon={item.icon}
                  title={translator(item.label)}
                  style={{ color: " black" }}
                  disabled={item.key === "2"}
                >
                  {item.children.map((child: any) => (
                    <Menu.Item
                      icon={child.icon}
                      key={child.key}
                      onClick={() => handleMenuItemClick(child.key)}
                    >
                      {translator(child.label)}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={item.key}
                  icon={item.icon}
                  onClick={() => handleMenuItemClick(item.key)}
                >
                  {item.label}
                </Menu.Item>
              ),
            )}
          </Menu>
          <div className={styles.fenrisBranding}>
            <div>{translator("poweredBy")}</div>
            <img
              src="/assets/logos/sideNavLogo.svg"
              alt="Motion2Coach"
              className={styles["side-nav-logo"]}
            />
          </div>
        </div>
      </Sider>
    </Spin>
  );
}
